var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6ZM5.99632 4.58232L8.11817 2.46132L9.53239 3.87553L7.41132 5.99632L9.53239 8.11817L8.11817 9.53239L5.99632 7.41132L3.87553 9.53239L2.46132 8.11817L4.58232 5.99632L2.46132 3.87553L3.87553 2.46132L5.99632 4.58232Z","fill":"#B13024"}));
}

Cross.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
